import { useState } from "react";
import api from "../Api";
import { useNavigate } from "react-router-dom";

export function useResetPassword(token) {
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setError("Wachtwoorden komen niet overeen");
            return;
        }
        try {
            await api.post("/users/reset-password", {
                token: token,
                new_password: newPassword,
            });
            setSuccess("Je wachtwoord is succesvol gereset.");
            setTimeout(() => {
                navigate("/login");
            }, 2000);
        } catch (err) {
            console.log("Error resetting password:", err);
            setError("Fout bij resetten van wachtwoord.");
        }
    };

    return {
        newPassword,
        setNewPassword,
        confirmPassword,
        setConfirmPassword,
        error,
        setError,
        success,
        handleSubmit,
    };
}
